<template>
  <wide-box-section-empty class="about">
    <div class="left-column">
      <ul>
        <li><a href="#" @click.prevent="goTo('about-auditlink')" :class="{ active: isActive('about') }">About AuditLink</a></li>
        <li><a href="#" @click.prevent="goTo('directors')" :class="{ active: isActive('directors') }">Our directors</a></li>
        <li><a href="#" @click.prevent="goTo('team')" :class="{ active: isActive('team') }">Our team</a></li>
        <li><a href="#" @click.prevent="goTo('join')" :class="{ active: isActive('join') }">Join the team</a></li>
      </ul>
      <img class="about-tick" src="../assets/tick.svg" alt="">
    </div>
    <div class="right-column">
      <router-view></router-view>
    </div>
  </wide-box-section-empty>
</template>

<script>
import WideBoxSectionEmpty from './WideBoxSectionEmpty'
import Velocity from 'velocity-animate'

export default {
  name: 'About',

  components: { WideBoxSectionEmpty },

  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      activeSection: 'about'
    }
  },

  methods: {
    goTo (section) {
      const column = this.$el.querySelector('.right-column')
      section = this.$el.querySelector('.' + section)
      Velocity(section, 'scroll', { container: column, offset: 1 })
    },

    isActive (section) {
      if (this.activeSection === section) {
        return true
      }
      return false
    },

    setActiveSection (position) {
      const aboutTop = 0
      const directorsTop = this.$el.querySelector('.directors').offsetTop
      const teamTop = this.$el.querySelector('.team').offsetTop
      const joinTop = this.$el.querySelector('.join').offsetTop

      const column = this.$el.querySelector('.right-column')
      const columnInner = this.$el.querySelector('.right-column .about-inner')
      const endOfSection = columnInner.offsetHeight - column.offsetHeight

      console.log(endOfSection, position, columnInner.offsetHeight)

      if (position >= aboutTop) {
        this.activeSection = 'about'
      }

      if (position >= directorsTop) {
        this.activeSection = 'directors'
      }

      if (position >= teamTop) {
        this.activeSection = 'team'
      }

      // last conditional required for IE, although it should be impossible to
      // scroll past the end of the section
      if (position >= joinTop || position === endOfSection || position > endOfSection) {
        this.activeSection = 'join'
      }
    }
  },

  mounted () {
    const column = this.$el.querySelector('.right-column')
    column.addEventListener('scroll', e => {
      this.setActiveSection(column.scrollTop)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/About.vue